// API-related constants

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  LOGOUT: '/api/auth/logout',
  YANDEX_AUTH: '/api/auth/yandex',
  
  // Workers
  WORKERS: '/api/v1/workers',
  WORKER_BY_ID: (id: number) => `/api/v1/workers/${id}`,
  WORKERS_IMPORT_CSV: '/api/v1/workers/import/csv',
  
  // Stores
  STORES: '/api/v1/stores',
  STORE_BY_ID: (id: number) => `/api/v1/stores/${id}`,
  STORES_FIX_ADDRESSES: '/api/v1/stores/fix-addresses',
  STORES_IMPORT_CSV: '/api/v1/stores/import/csv',
  
  // Programs
  PROGRAMS: '/api/v1/programs',
  PROGRAM_BY_ID: (id: number) => `/api/v1/programs/${id}`,
  PROGRAM_STORES: (programId: number) => `/api/v1/programs/${programId}/stores`,
  PROGRAM_STORE_BY_ID: (id: number) => `/api/v1/program-stores/${id}`,
  
  // Plans
  PLANS: '/api/v1/plans',
  PLAN_BY_ID: (id: number) => `/api/v1/plans/${id}`,
  PLAN_OPTIMIZE: (id: number) => `/api/v1/plans/${id}/optimize`,
  PLAN_ASSIGNMENTS: (id: number) => `/api/v1/plans/${id}/assignments`,
  PLAN_EXPORT_EXCEL: (id: number) => `/api/v1/plans/${id}/export/excel`,
  
  // Partners
  PARTNERS: '/api/v1/partners',
  PARTNER_BY_ID: (id: number) => `/api/v1/partners/${id}`,
  
  // Chains
  CHAINS: '/api/v1/chains',
  CHAIN_BY_ID: (id: number) => `/api/v1/chains/${id}`,
  
  // Business Types
  BUSINESS_TYPES: '/api/v1/business-types',
  BUSINESS_TYPE_BY_ID: (id: number) => `/api/v1/business-types/${id}`,
  
  // Regions & Settlements
  REGIONS: '/api/v1/regions',
  REGION_BY_ID: (id: number) => `/api/v1/regions/${id}`,
  SETTLEMENTS: '/api/v1/settlements',
  SETTLEMENT_BY_ID: (id: number) => `/api/v1/settlements/${id}`,
  
  // Time Matrix
  TIME_MATRIX: '/api/v1/time-matrix',
  TIME_MATRIX_CALCULATE: '/api/v1/time-matrix/calculate',
  
  // Import
  IMPORT_EXCEL: '/api/v1/import/excel',
  
  // Settings
  SETTINGS: '/api/v1/settings',
} as const;

// API Request Configuration
export const API_CONFIG = {
  TIMEOUT: 30000, // 30 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000, // 1 second
} as const;

// Query Keys for React Query
export const QUERY_KEYS = {
  // Workers
  WORKERS: ['workers'],
  WORKER: (id: number) => ['workers', id],
  
  // Stores
  STORES: ['stores'],
  STORE: (id: number) => ['stores', id],
  
  // Programs
  PROGRAMS: ['programs'],
  PROGRAM: (id: number) => ['programs', id],
  PROGRAM_STORES: (programId: number) => ['programs', programId, 'stores'],
  
  // Plans
  PLANS: ['plans'],
  PLAN: (id: number) => ['plans', id],
  PLAN_ASSIGNMENTS: (planId: number) => ['plans', planId, 'assignments'],
  
  // Partners
  PARTNERS: ['partners'],
  PARTNER: (id: number) => ['partners', id],
  
  // Chains
  CHAINS: ['chains'],
  CHAIN: (id: number) => ['chains', id],
  
  // Business Types
  BUSINESS_TYPES: ['businessTypes'],
  BUSINESS_TYPE: (id: number) => ['businessTypes', id],
  
  // Regions & Settlements
  REGIONS: ['regions'],
  REGION: (id: number) => ['regions', id],
  SETTLEMENTS: ['settlements'],
  SETTLEMENT: (id: number) => ['settlements', id],
  
  // Settings
  SETTINGS: ['settings'],
} as const;

// Batch Processing
export const BATCH_SIZES = {
  ADDRESS_FIX: 50,
  CSV_IMPORT: 500,
  GEOCODING: 25,
  EXPORT: 1000,
} as const;